import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

export default function Internship() {
  const { internship } = COURSE;
  return (
    <section id="internship" data-testid="internship-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="overflow-hidden rounded-[2rem] border border-[#293891]/10 bg-white shadow-[0_30px_80px_-50px_rgba(41,56,145,0.4)]">
          <div className="grid gap-0 lg:grid-cols-[1.1fr_0.9fr]">
            {/* left */}
            <div className="p-8 md:p-12">
              <Reveal>
                <Eyebrow>Real-Time Industry Projects &amp; Internship</Eyebrow>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-[2.9rem]">
                  Real experience, before your first job.
                </h2>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-6 max-w-lg text-base leading-relaxed text-[#566076]">{internship.intro}</p>
              </Reveal>

              <StaggerGroup className="mt-9 space-y-4">
                {internship.points.map((p) => (
                  <StaggerItem key={p} className="flex items-start gap-3">
                    <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-[#3B82F6]" />
                    <span className="text-sm text-[#3A4152] md:text-base">{p}</span>
                  </StaggerItem>
                ))}
              </StaggerGroup>
            </div>

            {/* right — stats panel */}
            <div className="relative flex flex-col justify-center gap-6 bg-[#293891] p-8 md:p-12">
              <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#3B82F6]/20 blur-3xl" />
              <span className="text-xs uppercase tracking-[0.24em] text-[#8ea0c4]">By the numbers</span>
              {internship.stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                  className="flex items-baseline gap-4 border-b border-white/10 pb-5 last:border-0"
                >
                  <span className="font-display text-5xl font-semibold text-white md:text-6xl">{s.value}</span>
                  <span className="text-sm uppercase tracking-[0.14em] text-[#c3cee3]">{s.label}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
